import { render } from "./EventStages.vue?vue&type=template&id=5335ffaf&scoped=true"
import script from "./EventStages.vue?vue&type=script&lang=js"
export * from "./EventStages.vue?vue&type=script&lang=js"

import "./EventStages.vue?vue&type=style&index=0&id=5335ffaf&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5335ffaf"]])

export default __exports__